// @ts-nocheck
// note setup chat section...
export const NEW_CHAT_SETUP_LOADING = "NEW_CHAT_SETUP_LOADING";
export const NEW_CHAT_SETUP_SUCCESS = "NEW_CHAT_SETUP_SUCCESS";
export const NEW_CHAT_SETUP_FAILURE = "NEW_CHAT_SETUP_FAILURE";
export const ON_NEW_NOTE_ONE_ON_ONE_CHAT = "ON_NEW_NOTE_ONE_ON_ONE_CHAT";
export const MARK_NOTE_RESOLVED = "MARK_NOTE_RESOLVED";
export const MARK_NOTE_UNRESOLVED= "MARK_NOTE_UNRESOLVED";
export const NOTE_CHATT_ROOM_MESSAGES_LOADING = "NOTE_CHATT_ROOM_MESSAGES_LOADING";
export const SET_NOTE_CHAT_ROOM_MESSAGES = "SET_NOTE_CHAT_ROOM_MESSAGES";
export const CLEAR_NOTE_CHAT_ROOM_MESSAGES = "CLEAR_NOTE_CHAT_ROOM_MESSAGES";
export const ON_MARK_UNREAD_NOTIFICATIONS = "ON_MARK_UNREAD_NOTIFICATIONS";
export const CREATE_NOTES_MOUNTED = "CREATE_NOTES_MOUNTED";
export const CREATE_NOTES_UNMOUNTED = "CREATE_NOTES_UNMOUNTED";

// note setup chat section...